



























import { Vue, Component, Prop, Model, Watch } from "vue-property-decorator"
import { mapGetters } from "vuex"

@Component({
    computed: {
        ...mapGetters(["orgUser", "allUser", "org", "havePreUser"])
    }
})
export default class SelectTree extends Vue {
    readonly allUser: any
    readonly orgUser!: any[]
    readonly org: any[]
    readonly havePreUser: any[]

    @Model("change", { type: [Number, Array] }) valueId?: number | number[]
    @Prop({ type: Boolean, default: false }) multiple: boolean
    @Prop({ type: String, default: "" }) placeholder: string
    @Prop({ type: Boolean, default: false }) disabled: boolean
    @Prop({ type: Boolean, default: false }) autoFocus: boolean
    @Prop({ type: Boolean, default: false }) onlyOrg: boolean
    @Prop({ type: Function }) getPopupContainer: any
    @Prop({ type: Boolean, default: false }) isChooseDepart: boolean // 单选选择部门
    @Prop({ type: Boolean, default: false }) needPreEnter: boolean

    treeData: any[] = []
    treeDataFlat: any = {}
    innerValue: number | number[] = null
    async created() {
        this.innerValue = this.valueId
        if (this.needPreEnter) {
            await this.$store.dispatch("user/getPreEnterList")
        } else if (this.onlyOrg && this.org.length == 0) {
            await this.$store.dispatch("user/getOrgList")
        } else if (!this.onlyOrg && this.orgUser.length == 0) {
            await this.$store.dispatch("user/getOrgUserList")
        }
        this.init()
        this.$nextTick(() => {
            if (this.autoFocus) {
                ;(this.$refs.tree as any).focus()
            }
        })
    }

    init() {
        if (this.needPreEnter) {
            this.handleTreeData(this.havePreUser)
        } else {
            this.handleTreeData(this.onlyOrg ? this.org : this.orgUser)
        }
    }

    @Watch("valueId")
    valueIdChange() {
        if (this.valueId !== this.innerValue) {
            this.innerValue = this.valueId
        }
    }
    handleChange(val: any, label: any, node: any) {
        if (Array.isArray(val) && !this.onlyOrg) {
            val = val.filter(v => this.allUser[v])
        }
        if (Array.isArray(val) && this.onlyOrg) {
            val = [val[val.length - 1]].filter(el => el)
        }
        const isDepart =
            node.triggerNode && node.triggerNode.dataRef ? node.triggerNode.dataRef.isDepart : false
        this.$emit("change", val)
        this.$emit("typeChange", isDepart)
    }

    handleTreeData(source_: any) {
        const source = JSON.parse(JSON.stringify(source_))
        const onlyOrg = this.onlyOrg
        const isChooseDepart = this.isChooseDepart
        const multiple = this.multiple
        function handle(arr: any[], oid: any[]) {
            const res: any[] = arr.map(obj => {
                let _arr = []
                if (obj.child_org && obj.child_org.length) {
                    _arr = handle(obj.child_org, oid.concat([obj.oid]))
                }
                obj.user_list = obj.user_list || []
                obj.user_list = obj.user_list.map((item: any) => {
                    return {
                        value: item.oid || item.uid,
                        label: item.name,
                        thumb_avatar: item.thumb_avatar,
                        parentId: oid.concat(obj.oid),
                        scopedSlots: { title: `${item.oid || item.uid}_title` }
                    }
                })
                // 过滤掉重复id
                obj.user_list = obj.user_list.reduce((arr: any, item: any) => {
                    if (!arr.find((v: any) => v.value == item.value)) {
                        arr.push(item)
                    }
                    return arr
                }, [])

                const list = obj.user_list.concat(_arr)
                return {
                    value: obj.oid || obj.uid,
                    label: obj.name,
                    isDepart: true,
                    selectable: isChooseDepart || onlyOrg,
                    scopedSlots: { title: "oid_title" },
                    children: list,
                    parentId: oid
                }
            })
            // 过滤空部门
            if (multiple) {
                return res.filter(res => !(res.isDepart && res.children.length == 0))
            }
            return res
        }
        const ret = handle(source, [])
        this.treeData = ret[0].children
        this.treeDataFlat = this.flatMap(this.treeData)
    }

    flatMap(arr: any[]) {
        const res = arr.reduce((obj, item) => {
            if (item.children && item.children.length) {
                Object.assign(obj, this.flatMap(item.children))
            }
            obj[item.value] = {
                id: item.value,
                avatar: item.thumb_avatar,
                name: item.label
            }
            return obj
        }, {})
        return res
    }
}
